import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames/bind";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import SwiperCore, { FreeMode } from "swiper";
import { AnimatePresence, motion } from "framer-motion";

// components
import Item from "../Item/Item";
import Footer from "../Footer/Footer";

import styles from "./Slider.module.scss";
const cx = classNames.bind(styles);

SwiperCore.use([FreeMode]);
let timer = null;

const Slider = ({
  events,
  isOpen,
  isGrow,
  toggle,
  handleDirection,
  handleClose,
}) => {
  const [activeRef, setActiveRef] = useState(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    if (events.length > 0) {
      setActiveRef({ ...events[0], index: 1 });
    }
  }, [events]);

  const handleSlideChange = (e) => {
    const { activeIndex } = e;

    clearTimeout(timer);

    timer = setTimeout(() => {
      const curr = events[activeIndex];
      handleDirection({
        id: curr.EventId,
        coords: {
          lat: Number(curr.Latitude),
          lng: Number(curr.Longitude),
        },
      });

      setActiveRef({
        ...curr,
        index: activeIndex + 1,
      });
    }, 350);
  };

  const handleNextSlide = () => {
    sliderRef.current.slideNext();
  };

  const handleInit = (e) => {
    sliderRef.current = e;
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className={cx("mob-slider-root")}
          >
            <Swiper
              spaceBetween={12}
              slidesPerView={1}
              slidesPerGroup={1}
              cssMode
              freeMode={{
                enabled: true,
                sticky: true,
              }}
              onSlideChange={handleSlideChange}
              onInit={handleInit}
            >
              {events.map((item, i) => (
                <SwiperSlide key={i}>
                  <Item data={item} isGrow={isGrow} toggle={toggle} />
                </SwiperSlide>
              ))}
            </Swiper>
          </motion.div>
          <Footer
            isOpen={isOpen}
            activeRef={activeRef}
            length={events.length}
            handleClose={handleClose}
            handleNextSlide={handleNextSlide}
          />
        </>
      )}
    </AnimatePresence>
  );
};

export default Slider;
